import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import TutorialBoardList from './TutorialBoardList';
import TutorialBoardView from './TutorialBoardView';
import TutorialCommunity from './TutorialCommunity';
import TutorialFeatureGuide from './TutorialFeatureGuide';
import './TutorialReal.css';

const STAGES=[
 ['boardlist','Your Boards','▦'],
 ['boardview','Using a Board','💬'],
 ['sentence','Sentence Builder','🧩'],
 ['editing','New Editing Mode','✏️'],
 ['stickycore','Sticky Core','📌'],
 ['ai','Create with AI','✨'],
 ['presets','Preset Boards','🗂️'],
 ['settings','New Settings','⚙️'],
 ['community','Community Boards','🌍'],
];
const key=()=>{try{const t=localStorage.getItem('token');const p=t?JSON.parse(atob(t.split('.')[1])):null;return `tutorialProgress:v3:${p?.sub||'anon'}`}catch{return 'tutorialProgress:v3:anon'}};
const load=()=>{try{return JSON.parse(localStorage.getItem(key())||'null')}catch{return null}};
const save=p=>{try{localStorage.setItem(key(),JSON.stringify(p))}catch{}};

export default function TutorialPage({forcedStage}){
 const [params]=useSearchParams(); const saved=load(); const force=STAGES.some(([k])=>k===forcedStage)?forcedStage:null;
 const [state,setState]=useState(()=>force?{stage:force,steps:saved?.steps||{}}:(params.get('start')==='1'||!saved?{stage:'boardlist',steps:{}}:saved));
 useEffect(()=>save(state),[state]);
 const idx=STAGES.findIndex(([k])=>k===state.stage);
 const next=()=>idx<STAGES.length-1?setState(s=>({...s,stage:STAGES[idx+1][0]})):setState(s=>({...s,stage:'done'}));
 const step=i=>setState(s=>({...s,steps:{...s.steps,[s.stage]:i}}));
 if(state.stage==='done')return <div className="tut-page"><div className="tut-shell"><div className="tut-hero"><small>iBoard AAC Help</small><h1>Tutorial complete</h1><p>Choose any section below whenever you want a refresher.</p></div><div style={{display:'grid',gap:10}}>{STAGES.map(([k,n,icon])=><button key={k} onClick={()=>setState(s=>({...s,stage:k}))} style={{display:'grid',gridTemplateColumns:'42px 1fr auto',alignItems:'center',gap:12,padding:14,border:'1px solid #e1e6ec',borderRadius:12,background:'#fff',textAlign:'left'}}><span style={{fontSize:22}}>{icon}</span><b>{n}</b><span style={{fontSize:24,color:'#98a2b3'}}>›</span></button>)}</div></div></div>;
 const props={onDone:next,initialStepIndex:state.steps?.[state.stage]||0,onStepChange:step};
 if(state.stage==='boardlist')return <TutorialBoardList {...props}/>;
 if(state.stage==='boardview')return <TutorialBoardView {...props}/>;
 if(state.stage==='community')return <TutorialCommunity {...props}/>;
 return <TutorialFeatureGuide feature={state.stage} {...props}/>;
}
